@if (initials()) {
  {{ initials() }}
} @else {
  <div class="icon icon-user"></div>
}
